import { render, staticRenderFns } from "./reservation-card.vue?vue&type=template&id=6274f114&scoped=true"
import script from "./reservation-card.vue?vue&type=script&lang=js"
export * from "./reservation-card.vue?vue&type=script&lang=js"
import style0 from "./reservation-card.vue?vue&type=style&index=0&id=6274f114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6274f114",
  null
  
)

export default component.exports